export const regexPattern = {
  name: /^(?!.*[-'’]{2})(?![-'’])[a-zA-Z]+(?:[-'’ ]?[a-zA-Z]+)*(?<![-'’ ])$/,
  schoolName: /^(?!.*[-'’]{2})(?![-'’])[a-zA-Z0-9]+(?:[-'’ ]?[a-zA-Z0-9]+)*(?<![-'’ ])$/,
  city: /^(?! )(?!.*\s$)(?!.*--)(?!.* {2})(?!.* -)(?!.*- )([A-Za-z .,'-]{1,30})$/,
  address: /^[\w\d\s#.,-]+$/,
  zip: /^\d{5}(-\d{4})?$/,
  onlyFiveDigitZip: /^\d{5}$/,
  email: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
  globalEmail: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
  globalZipCode: /^(?!0{5})(\d{5})(?:[-\s]?(\d{4}))?$/, // Regular expression for U.S. zip code (5 digits or 5 digits + 4 digits)
  globalPhoneNumber: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/, // 10-digit phone numbers
  globalOnlyNumbers: /^\d+$/, // Regular expression to allow only numbers
};
